import { createContext } from "react";

type HeaderActionsContextType = {
  slot: HTMLElement | null;
};

export const HeaderActionsContext = createContext<HeaderActionsContextType>({
  slot: null,
});
